import {useCallback, useContext} from "react";
import CountryContext from "../CountryContext";
import useCountryAxiosInstance from "./useCountryAxiosInstance";

const useServiceAps = (serviceId, pageSize=null) => {
  const { country } = useContext(CountryContext);
  const countryApiRequest = useCountryAxiosInstance(country?.code);

  return useCallback(
    async (search=null, page=null, sortMode='asc', activeOnly=false, includeItems=false) => {
      // build request params
      const params = {
        id_service: serviceId,
        join: 'price_analysis_item',
      };
      if (!!search) {
        params['des_title'] = search;
        params['des_description'] = search;
        params['like'] = 'des_title,des_description';
      }
      if (!!sortMode) {
        params[sortMode] = 'des_title';
      }
      if ((!!page || page === 0) && !!pageSize) {
        params['skip'] = page * pageSize;
        params['limit'] = pageSize;
      }
      if (!!activeOnly) {
        params['flg_active'] = true;
      }
      // retrieve aps
      const aps = await countryApiRequest.get(`/services_price_analysis/all`, {params});
      // retrieve aps items (if requested)
      if (aps.length && includeItems) {
        const items = await countryApiRequest.get(
          `/services_price_analysis_items/by_aps_ids/${aps.map((c) => c.id).join(',')}`,
          {params: {join: 'price_analysis_item'}}
        );
        aps.forEach((ap, idx, arr) => {
          arr[idx] = {
            ...ap,
            items: items.filter((a) => a.id_service_price_analysis === ap.id)
          };
        })
      }

      // get total number of records (useful for pagination)
      const {skip, limit, ...totalParamsSearch} = params;
      const totalParams = {...totalParamsSearch, id_service: serviceId};
      if (!!activeOnly)
        params['flg_active'] = true;
      const total = await countryApiRequest.get(`/services_price_analysis/count`, {params: totalParams});

      return {
        rows: aps,
        total: total
      };
    },
    [serviceId, pageSize, countryApiRequest],
  );
}

export default useServiceAps;